import React, { useState } from 'react';
import { Switch } from 'antd';

const FormSwitch = ({ header, setValue }) => {
  const [switchValue, setSwitchValue] = useState(false);
  const updateDescription = (value) => {
    console.log(value);
    setSwitchValue(value);
    setValue(value);
  };
  return <div className="input-wrapper horizontal">
    <h3 className="input-header">{header}</h3>
    <Switch
      onChange={updateDescription}
    />
    <div className="value-description">
      { !switchValue && <span>En ole</span>}
      { switchValue && <span>Kyllä olen</span>}
    </div>
  </div>
};

export default FormSwitch;
